export const formatTime = (timeInLong) => {
  if (timeInLong) {
    return new Date(timeInLong).toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  } else {
    return '';
  }
};
